import React, { FC, PropsWithChildren } from 'react'
import { HasSidebarLayout, DataLoad, ListHeader, PropsInjector, GatewayList } from 'src/components'
import { useGatewayStatesRequest } from 'src/hooks/api'

const GatewayStateLoader: FC<PropsWithChildren> = ({ children }) => {
  const { data, isInitialLoading, isError } = useGatewayStatesRequest()
  return (
    <DataLoad isLoading={isInitialLoading} isError={isError}>
      <PropsInjector props={{ states: data || [] }}>{children}</PropsInjector>
    </DataLoad>
  )
}

const GatewayListPage: FC = () => {
  document.title = 'CLīMIT Admin Panel - LoRaWan Gateways'
  return (
    <HasSidebarLayout>
      <ListHeader title="LoRaWan Gateways"></ListHeader>
      <GatewayStateLoader>
        <GatewayList />
      </GatewayStateLoader>
    </HasSidebarLayout>
  )
}

export default GatewayListPage
